<template>
  <AuthenticatedLayout activeMenuItem='report-organisations-users' title='Reports'>
    <PaddedLayout>
      <div class='flex flex-wrap flex-col sm:flex-row py-2 justify-between sm:items-center gap-2 w-full max-w-[80rem]'>
        <h1 class='text-2xl'>Organisations & Users Report</h1>
        <!-- <a :href='pdfUrl' target='_blank' type="submit" class="rounded-md bg-jananavy-900 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-jananavy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-jananavy-600">Export PDF</a> -->
      </div>
      <div class='mt-2'>
        <TabView :tabs='tabs' v-model='state.tab' />

        <div v-if='state.tab === "organisations"' class='mt-8'>
          <GraphOrganisationSummariesTable />
        </div>

        <div v-if='state.tab === "users"' class='mt-8'>
          <GraphUserSummariesTable />
        </div>
      </div>
    </PaddedLayout>
  </AuthenticatedLayout>
</template>

<script setup>

import { reactive, ref, watch } from 'vue';

import { appendStateToRoute, getStateFromRoute } from '@/router';
import { getReportPDFExportUrl } from '@/kernel/report';

import AuthenticatedLayout from '@/components/layouts/authenticated-layout.vue';
import PaddedLayout from '@/components/layouts/padded-layout.vue';

import TabView from '@/components/views/tab-view.vue';

import GraphOrganisationSummariesTable from '@/components/reports/graphs/graph-organisation-summaries-table.vue';
import GraphUserSummariesTable from '@/components/reports/graphs/graph-user-summaries-table.vue';

const tabs = [
  { name: 'Organisations', key: 'organisations' },
  { name: 'Users', key: 'users' }
];

const getDefaultState = (preload) => {
  return {
    tab: preload?.tab || 'organisations'
  }
}

const routeState = getStateFromRoute();
const state = reactive(getDefaultState(routeState));
const pdfUrl = ref(getReportPDFExportUrl());

watch(() => state.tab, () => {
  appendStateToRoute(state);
});

</script>
